class ProdutoHistoricoModal {

    static get $inject() {
        return ['$scope', 'gql']
    }

    constructor($scope, gql) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
    }

    $onInit() {
        this.promise = this
            .loadHistoricos()
            .then(({ historicos, produto }) => {
                this.produto = produto
                this.historicos = historicos.map(historico => {
                    const newValues = Object
                        .entries(historico.newValues)
                        .filter(([field, value]) => !angular.equals(historico.oldValues[field], value))
                        .map(([field, value]) => {
                            const from = historico.oldValues[field] 
                            const to = value

                            if (field == 'tipoDestinacao')
                                return { from: this.formatTipoDestinacao(from), to: this.formatTipoDestinacao(to), field }
                            else
                                return { from, to, field }
                        })

                    return { ...historico, newValues }
                })
            })
            .finally(() => this.apply())
    }

    loadHistoricos() {
        const query = gql`
            query ListHistorico($filialId: Int!, $produtoId: String!){
                filial(id: $filialId){
                    id
                    produto(id: $produtoId){
                        id
                        codigo
                        historicos {
                            id
                            operacao
                            origem
                            insertedAt
                            newValues {
                                descricao
                                codigoBarras
                                ncm
                                exTipi
                                cest
                                tipoDestinacao {
                                    codigo
                                    descricao
                                }
                                ativo
                                foto
                            }
                            oldValues {
                                descricao
                                codigoBarras
                                ncm
                                exTipi
                                cest
                                tipoDestinacao {
                                    codigo
                                    descricao
                                }
                                ativo
                                foto
                            }
                            usuario {
                                id
                                nome
                            }
                            nfeItem{
                                id
                                nfe {
                                    id
                                    chave
                                    numero
                                    emissaoPropria
                                    emitente {
                                        id
                                        nome
                                        cpfCnpj
                                    }
                                }
                            }
                            efdItem{
                                id
                                efd {
                                    id
                                    tipo
                                    dataReferencia
                                }
                            }
                        }
                    }
                }
            }
        `

        const { filialId, produtoId } = this.resolve

        return this.gql
            .query(query, { filialId, produtoId })
            .then(result => {
                const produto = result.filial.produto
                const historicos = produto.historicos
                    .sort((h1, h2) => h1.insertedAt > h2.insertedAt ? -1 : 1)

                return { produto, historicos }
            })
    }

    formatTipoDestinacao(tipo) {
        if (tipo) {
            return `${tipo.codigo} - ${tipo.descricao}`
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('produtoHistoricoModal', {
        controller: ProdutoHistoricoModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal modal-title="Histórico de alterações" close="$ctrl.close">
            <modal-body>
                <loading promise="$ctrl.promise">
                    <highlighted>
                        <main>Alterações do produto</main>
                        <secondary ng-hide="$ctrl.historicos.length">Nenhuma alteração encontrada para este produto.</secondary>
                        <secondary ng-show="$ctrl.historicos.length">Confira abaixo as alterações do produto de código <b>{{$ctrl.produto.codigo}}</b>.</secondary>
                    </highlighted>
                    <div class="historico" ng-repeat="historico in $ctrl.historicos">
                        <div class="historico-header" ng-click="historico.show = !historico.show">
                            <span ng-switch="historico.origem">
                                <span ng-switch-when="MANUAL">
                                    <b>{{historico.usuario.nome}}</b> {{historico.operacao == 'CREATE' ? 'cadastrou' : 'alterou'}} este produto.
                                </span>
                                <span ng-switch-when="NFE_ITEM">
                                    A importação da NF-e <b>{{historico.nfeItem.nfe.chave}}</b>
                                    {{historico.operacao == 'CREATE' ? 'cadastrou' : 'alterou'}} este produto.
                                </span>
                                <span ng-switch-when="EFD_ITEM">
                                    A importação da EFD {{historico.efdItem.efd.tipo == 'ICMS' ? 'ICMS' : 'PIS/COFINS'}}
                                    do mês <b>{{historico.efdItem.efd.dataReferencia | date: 'MM/yyyy'}}</b>
                                    {{historico.operacao == 'CREATE' ? 'cadastrou' : 'alterou'}} este produto.
                                </span>
                            </span>
                                
                            <span class="text-muted">
                                {{historico.operacao == 'CREATE' ? 'Cadastrado': 'Alterado' }} em {{historico.insertedAt | date: 'dd/MM/yyyy HH:mm'}}
                            </span>
                        </div> 

                        <div class="historico-body slide-animation" ng-show="historico.show">
                            <div class="historico-nfe-info" ng-show="historico.origem == 'NFE_ITEM'">  
                                <span>
                                    <b>Número</b>
                                    <br />
                                    {{historico.nfeItem.nfe.numero}}
                                </span>
                                <span>
                                    <b>Emitente</b>
                                    <br />
                                    <span ng-hide="historico.nfeItem.nfe.emissaoPropria">{{historico.nfeItem.nfe.emitente.nome}} {{historico.nfeItem.nfe.emitente.cpfCnpj | cpfCnpj}}</span>
                                    <span ng-show="historico.nfeItem.nfe.emissaoPropria">Emissão própria</span>
                                </span>
                            </div>

                            <hr ng-show="historico.origem == 'NFE_ITEM'">
                           
                            <div class="historico-changes">
                                <div ng-repeat="alteracao in historico.newValues">
                                    <b ng-switch="alteracao.field">
                                        <span ng-switch-when="descricao">Descrição</span>
                                        <span ng-switch-when="codigoBarras">Código de barras</span>
                                        <span ng-switch-when="ncm">NCM</span>
                                        <span ng-switch-when="exTipi">EX TIPI</span>
                                        <span ng-switch-when="cest">CEST</span>
                                        <span ng-switch-when="tipoDestinacao">Tipo de destinação</span>
                                        <span ng-switch-when="ativo">Status</span>
                                        <span ng-switch-when="foto">Foto</span>
                                    </b>
                                    <div ng-if="(alteracao.field != 'foto') && (alteracao.field != 'ativo') ">
                                        <div ng-show="historico.operacao == 'CREATE'">
                                            <span>{{alteracao.to}}</span>        
                                        </div>
                                        <div class="historico-change" ng-hide="historico.operacao == 'CREATE'">
                                            <span ng-if="alteracao.from">{{alteracao.from}}</span>
                                            <span ng-if="!alteracao.from" class="text-muted">VAZIO</span>
                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                            <span ng-if="alteracao.to">{{alteracao.to}}</span>
                                            <span ng-if="!alteracao.to" class="text-muted">VAZIO</span>
                                        </div>
                                    </div>
                                    <div ng-if="alteracao.field == 'foto'">
                                        A foto foi alterada.
                                    </div>

                                    <div ng-if="alteracao.field == 'ativo'">
                                        <span ng-if="alteracao.from">Ativo</span>
                                        <span ng-if="!alteracao.from">Inativo</span>
                                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        <span ng-if="alteracao.to">Ativo</span>
                                        <span ng-if="!alteracao.to">Inativo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </loading>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
